<template>
  <Teleport to="body">
    <transition name="assistance-fade">
      <div v-if="show" class="assistance-overlay">
        <div class="modal-backdrop-custom" @click="$emit('close')"></div>

        <div class="modal-dialog assistance-dialog">
          <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title d-flex align-items-center gap-2 p-2">
              <i class="bi bi-exclamation-triangle-fill assistance-icon-pulse me-1" style="color: var(--warning);"></i>
              {{ translate('assistance.title', 'Customer Needs Assistance') }}
            </h5>
          </div>

          <!-- assistance alert -->
          <div class="modal-body text-center py-3">
            <div v-if="interaction" class="customer-info-box mb-3">
              <div class="fw-semibold">
                {{ interaction.customerName || interaction.name || translate('customers.unknown', 'Unknown customer') }}
              </div>
              <div class="text-muted small mt-1">
                <i class="bi bi-telephone me-1"></i>{{ (interaction.phone || '').replace('whatsapp:', '').replace('+', '') }}
              </div>
            </div>
            <p class="text-muted small mb-0">
              {{ translate('assistance.description', 'A customer is requesting help and needs your immediate attention.') }}
            </p>
          </div>

          <!-- footer -->
          <div class="modal-footer justify-content-center gap-2">
            <button class="btn btn-primary fw-bold" @click="onContact">
              {{ translate('assistance.accept', 'Accept') }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
  </Teleport>
</template>

<script>
import { useStore } from 'vuex'

export default {
  name: 'AssistanceAlertModal',
  props: {
    show: { type: Boolean, default: false },
    interaction: { type: Object, default: null }
  },
  emits: ['contact', 'close'],
  setup(props, { emit }) {
    const store = useStore()
    const translate = (key, fallback) => store.getters.translate(key, fallback)

    const onContact = () => {
      emit('contact')
    }

    const onClose = () => {
      emit('close')
    }

    return { translate, onContact, onClose }
  }
}
</script>

<style scoped>
.assistance-overlay {
  position: fixed;
  inset: 0;
  z-index: 1055;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1054;
}

.assistance-dialog {
  position: relative;
  z-index: 1056;
  width: 100%;
  max-width: 400px;
}

.assistance-dialog .modal-content {
  background-color: #ffffff;
}

.assistance-dialog .modal-header {
  padding: 1.25rem 2rem;
}

.assistance-dialog .modal-footer {
  padding: 1.25rem 2rem;
}

.assistance-header .modal-title {
  font-size: 1rem;
  font-weight: 600;
}

.assistance-icon-pulse {
  font-size: 1.2rem;
  animation: icon-pulse 1.4s ease-in-out infinite;
}

.customer-info-box {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 0.65rem 1rem;
  display: inline-block;
  min-width: 180px;
}

@keyframes icon-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%       { opacity: 0.6; transform: scale(1.15); }
}

.assistance-fade-enter-active,
.assistance-fade-leave-active { transition: opacity 0.25s ease; }
.assistance-fade-enter-from,
.assistance-fade-leave-to     { opacity: 0; }
</style>
